// extracted by mini-css-extract-plugin
export default {"title":"NickoTermsOfLiability_title__d3P60","paragraph":"NickoTermsOfLiability_paragraph__9nfoA"};